import { render } from "./CatalogSelect.vue?vue&type=template&id=6d92c1cf"
import script from "./CatalogSelect.vue?vue&type=script&lang=js"
export * from "./CatalogSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__